const selectors = {
  classes: (state) => state.classes.classes,
  currentClass: (state) => state.classes.currentClass,
  nextAppointment: (state) => state.classes.nextAppointment,
  prevAppointment: (state) => state.classes.prevAppointment,
  currentClassLoadStatus: (state) => state.classes.currentClassLoadStatus,
  nextAppointmentLoadStatus: (state) => state.classes.nextAppointmentLoadStatus,
  prevAppointmentLoadStatus: (state) => state.classes.prevAppointmentLoadStatus,
};

export { selectors };
